module.exports = __webpack_public_path__ + "img/logo.fae1c54d.png";